import createCtx from 'coreUtils/createCtx';

export const [useSocialLoginContext, SocialLoginContextProvider] = createCtx<{
	onLogin: (identityProviderName: string, isRedirectLogin: boolean) => Promise<void>;
}>();
